export default "__VITE_ASSET__2b30ed80__"